module.exports = __webpack_public_path__ + "img/fr4.a6b282d2.jpg";